const reactSelectSkin = {
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: "#000000", // hard-coded value so it will work for both dark and light skins
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: "#000000", // hard-coded value so it will work for both dark and light skins
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    boxShadow: "var(--gc-box-shadow-primary)",
  }),
};

export default reactSelectSkin;
